import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#AA0132",
      stroke: "#AA0132",
      "stroke-width": ".5",
      d: "M8.76 1.348a.57.57 0 0 1 .749-.3.577.577 0 0 1 .302.758l-2.6 6.142H18.79l-2.6-6.136a.586.586 0 0 1 .302-.759.565.565 0 0 1 .749.301l2.789 6.594h4.4c.314 0 .571.26.571.579v2.316a.577.577 0 0 1-.571.579h-.623l-.995 10.015A1.71 1.71 0 0 1 21.11 23H4.89a1.72 1.72 0 0 1-1.708-1.563l-.989-10.015H1.57a.577.577 0 0 1-.571-.58V8.528c0-.318.257-.579.571-.579h4.4Zm14.158 10.074H3.088l.977 9.9c.028.294.53.785.826.785H21.11c.291 0 .798-.49.826-.786zm1.3-2.735H1.782v1.855h22.434z"
    }, null, -1)
  ])))
}
export default { render: render }